import React from 'react';
import '../../index.css';

export default function SignUp() {
  return <h1 className="sign-up">SIGN UP</h1>;
}
